import { updateItemInCollection } from "directus/src/operations";

export async function updateTool({ item, toolId }) {
  try {
    const data = await updateItemInCollection("tools", toolId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
